import React from "react";

import FCalendar from "./components/FCalendar";
import FollowUpCalendarProvider from "./context/FollowUpCalendarContext";

function FollowUpCalendar() {
  return (
    //Unfortunatly Need extra level to pass provider through child of FollowUpCalendar to access state.
    <FollowUpCalendarProvider>
      <FCalendar />
    </FollowUpCalendarProvider>
  );
}

export default FollowUpCalendar;
